<template>

  <div class="col-span-2">
    <ui-data-grid>
      <ui-data-grid-section title="Materials" half>

        <div class="col-span-2 border border-gray-200 rounded-md text-sm" v-if="materials.length">
          <table class="max-w-full w-full table-fixed">
            <thead class="w-full">
              <tr class="w-full">
                <th class="text-left px-4 py-3 text-sm text-uppercase max-w-3/4">Item</th>
                <th class="text-right px-4 py-3 text-sm text-uppercase w-1/4">Cost Per {{ uom }}</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 w-full">
            <tr v-for="material in materials" :key="material.id" class="w-full">
              <td class="truncate text-sm font-bold text-left px-4 py-3 break-words max-w-3/4">
                {{ material.name }}<br />
                <span class="text-xs font-light">{{ material.coverage }} {{ uom }} per {{ material.unit_of_measure ? material.unit_of_measure : 'item' }} of material.</span>
                <span class="block text-xs font-light" v-if="material.price_per_uom == 0">Add a sale cost <a class="text-brand hover:text-brand-light" :href="material._links.frontend.view">here</a>.</span>
              </td>
              <td class="font-bold text-right px-4 py-3 align-top break-words w-1/4">
                {{ material.price_per_uom | toCurrency }}<br /><span class="font-light text-xs text-right">per  {{ uom }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="py-4 text-left text-gray-500" v-else>
          No Materials
        </div>

      </ui-data-grid-section>
      <ui-data-grid-section title="Labour" half>

        <div class="col-span-2 border border-gray-200 rounded-md text-sm" v-if="labour.length">
          <table class="max-w-full w-full table-fixed">
            <thead class="w-full">
            <tr class="w-full">
              <th class="text-left px-4 py-3 text-sm text-uppercase max-w-3/4">Rate</th>
              <th class="text-right px-4 py-3 text-sm text-uppercase w-1/4">Cost Per {{ uom }}</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 w-full">
            <tr v-for="labourRate in labour" :key="labourRate.id" class="w-full">
              <td class="truncate text-sm font-bold text-left px-4 py-3 break-words max-w-3/4">
                {{ labourRate.name }}<br />
                <span class="text-xs font-light">{{ labourRate.coverage_per_hour }} {{ uom }} per hour at {{ labourRate.price_per_hour | toCurrency }} per hour</span>
              </td>
              <td class="font-bold text-right px-4 py-3 align-top break-words w-1/4">{{ labourRate.price_per_uom | toCurrency }}<br /><span class="font-light text-xs text-right">per {{ uom }}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="py-4 text-left text-gray-500" v-else>
          No Labour Rates
        </div>

      </ui-data-grid-section>
    </ui-data-grid>
  </div>

</template>

<script>
export default {
  props: {
    materials: Array,
    labour: Array,
    uom: String
  },
  computed: {
    //
  },
  methods: {
    //
  },
}
</script>
